export enum MuxPlaybackPolicy {
	public = 'public',
	signed = 'signed',
	drm = 'drm',
}

export interface MuxPlaybackIdRetrieveResponse {
	drm_configuration_id?: string;
	id?: string;
	object?: {
		type: string;
		id: string;
	};
	policy: string;
}
